import { render, staticRenderFns } from "./createTemplate.vue?vue&type=template&id=cb7e5a1a&scoped=true"
import script from "./createTemplate.vue?vue&type=script&lang=js"
export * from "./createTemplate.vue?vue&type=script&lang=js"
import style0 from "./createTemplate.vue?vue&type=style&index=0&id=cb7e5a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7e5a1a",
  null
  
)

export default component.exports